import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ReactDOM from 'react-dom/client';
import Home from "./pages/home/Home";
import Donation from "./pages/donation/Donation";
import Volunteer from "./pages/volunteer/Volunteer";
import Partners from "./pages/partners/Partners";
import About from "./pages/about/About";
import Research from "./pages/research-and-data/Research";
import SinglePost from "./pages/singlepost/SinglePost";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import GoogleTranslateLoader from "./components/googletraslater/GoogleTranslateLoader";
import SingleProject from './pages/singleprojecrt/SingleProject';
import ProspectiveProjects from './pages/prospectiveprojects/ProspectiveProjects';
import GammaddaUniverse from './pages/gammadda-universe/GammaddaUniverse';
import OngoinProject from './pages/ongoin-project/OngoinProject';
import VestedProject from './pages/vested-project/VestedProject';
import GammaddaThaksalava from './pages/gammadda-thaksalava/GammaddaThaksalava';
import AllLatestUpdate from './pages/all-latest-update/AllLatestUpdate';
import GammaddaNagitimuSriLanka from './pages/gammadda-nagitimu-sri-lanka/GammaddaNagitimuSriLanka';
import GammaddaSmiles from './pages/gammadda-smiles/GammaddaSmiles';
import EducationalAssistanceProgram from './pages/educational-assistance-program/EducationalAssistanceProgram';
import ReachOut from './pages/reach-out/ReachOut';



function App() {
  return (
    
    <Router>
    <Header />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/make-a-donation" element={<Donation />} />
      <Route path="/gammadda-volunteering" element={<Volunteer />} />
      <Route path="/gammadda-partners" element={<Partners />} />
      <Route path="/about" element={<About />} />
      <Route path="/research-and-data" element={<Research />} />
      <Route path="/prospective-projects" element={<ProspectiveProjects/>} />
      <Route path="/news/:slug" element={<SinglePost />} />
      <Route path="/projects/:slug" element={<SingleProject />} />
      <Route path="/gammadda-universe" element={<GammaddaUniverse/>} />
      <Route path="/ongoing-projects" element={<OngoinProject/>}/>
      <Route path="/vested-projects" element={<VestedProject/>} />
      <Route path="/gammadda-thaksalava" element={<GammaddaThaksalava/>} />
      <Route path="/latest-updates" element={<AllLatestUpdate/>} />
      <Route path="/gammadda-nagitimu-sri-lanka" element={<GammaddaNagitimuSriLanka/>} />
      <Route path="/gammadda-smiles" element={<GammaddaSmiles/>} />
      <Route path="/educational-assistance-program" element={<EducationalAssistanceProgram/>} />      
      <Route path="/reach-out" element={<ReachOut/>} />      
      {/* <Route path="/about" element={<About />} /> */}
    </Routes>
    <Footer/>
    <GoogleTranslateLoader/>
  </Router>
  );
}

export default App;
